export class Countdown{
	init() {
		var countDownDate = new Date("Jun 01, 2022 14:00:00").getTime();

	// Update the count down every 1 second
	if(document.getElementById("countdown") !== null){
		let html = document.querySelector('html');
		
		var x = setInterval(function() {

		// Get today's date and time
			var now = new Date().getTime();

			// Find the distance between now and the count down date
			var distance = countDownDate - now;

			// Time calculations for days, hours, minutes and seconds
			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

			if(hours < 10){
				hours = "0"+hours;
			}
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			if(minutes < 10){
				minutes = "0"+minutes;
			}
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);
			if(seconds < 10){
				seconds = "0"+seconds;
			}

			let daysLabel = '',
				hoursLabel = '',
				minutesLabel = '',
				secondsLabel = '';

			if(html.lang == 'pl'){
				daysLabel = 'Dni';
				hoursLabel = 'Godz.';
				minutesLabel = 'Min.';
				secondsLabel = 'Sek.';
			}else{
				daysLabel = 'Days';
				hoursLabel = 'Hrs.';
				minutesLabel = 'Min.';
				secondsLabel = 'Sec.';
			}

			// Display the result in the element with id="demo"
				document.getElementById("countdown").innerHTML = "<div><div class='segment'><span class='large'>"+days 
				+ "</span><br><span>"+ daysLabel +"</span></div><div class='segment'><span class='large'>" + hours 
				+ "</span><br><span>"+ hoursLabel +"</span></div><div class='segment'><span class='large'>"+ minutes 
				+ "</span><br><span>"+ minutesLabel +"</span></div><div class='segment'><span class='large'>" + seconds + "</span><br><span>"+ secondsLabel +"</span></div></div>";				


			// If the count down is finished, write some text
			if (distance < 0) {
				clearInterval(x);
					document.querySelectorAll(".countdown-container")[0].style.display = "none";
					document.querySelectorAll(".countdown-container")[0].remove();
				}
			}, 1000);
		}
	}
}